import React, { useState } from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { navigate } from 'gatsby';
import Cookies from 'js-cookie';
import MoonLoader from 'react-spinners/MoonLoader';
import Select from 'react-select';
import axios from 'axios';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
/* --- import Components ----*/
import {
  InputForm,
  InputFormLarge,
  Label,
  NextBtn,
  RightInputWrapper,
  TwoInputWrapper,
} from '../../Form/elements';
import { ContactInfoItem, IconWrapper, StyledDate, StyledSentence } from '../../Events/elements';
import { InputPhone, selectStyleLarge } from 'src/components/Form/elements';
import { SentenceSmall, StyledLinkMedium, SubtitleDescription } from 'src/components/Typography';
import CameraBlack from 'src/components/Icons/Visio/CameraBlack';
import Clock from 'src/components/Icons/Clock';
import ErrorMessage from '../../Form/ErrorMessage';
import Location from 'src/components/Icons/location';
import Price from 'src/components/Icons/Price';
import FinalBlockLanding from './FinalBlockLanding';
/* --- import Style ----*/
import colors from 'src/style/colors';
import { flags } from '../../Icons/Flags';
import { mediaQueries } from 'src/style/breakpoints';
/* --- import Utils ----*/
import { formattingEvents } from '../formattingEvents';

const FORM_NAME = 'event-form';

const FormBlockSchema = Yup.object().shape({
  meetup: Yup.string().required('Champ obligatoire'),
  firstName: Yup.string().required('Champ obligatoire'),
  lastName: Yup.string().required('Champ obligatoire'),
  email: Yup.string()
    .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 'Email non valide')
    .required('Champ obligatoire'),
  zipCode: Yup.string().required('Champ obligatoire'),
  phoneNumber: Yup.string()
    .required('Champ obligatoire')
    .test({
      test: (num) => {
        if (num) {
          if (num.indexOf('+330') !== -1) {
            num = num.replace('+330', '+33');
            return isPossiblePhoneNumber(num);
          } else {
            return isPossiblePhoneNumber(num);
          }
        }
      },
      message: 'Numéro de téléphone non valide',
    }),
  utmSource: Yup.string(),
  gclid: Yup.string(),
  fbclid: Yup.string(),
  referrer: Yup.string(),
});

const FormBlock = ({
  dataFromMeetup,
  selectedEvent,
  pageType,
  formCompleted,
  setFormCompleted,
  manager,
}) => {
  const allEvents = formattingEvents(dataFromMeetup);
  const [formError, setFormError] = React.useState(false);
  const [eventDetail, setEventDetail] = React.useState(
    selectedEvent ? selectedEvent : allEvents[0]
  );
  const [isLoading, setIsLoading] = useState(false);
  const landing = pageType === 'landingPage' ? true : false;

  const initialValues = {
    meetup: eventDetail.value,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    utmSource: Cookies.get('tracking') || Cookies.get('utm_source') || '',
    gclid: Cookies.get('_gcl_aw') || '',
    fbclid: Cookies.get('fbclid') || '',
    referrer: Cookies.get('referrer') || '',
    zipCode: '',
    // ...(manager.get(FORM_NAME) || {}),
  };

  // useEffect(() => {
  // if (selectedEvent !== undefined) {
  // initialValues.meetup = selectedEvent.value;

  // let copy = { ...eventDetail };
  // const copy = selectedEvent;
  // setEventDetail(selectedEvent);
  // } else {
  // initialValues.meetup = allEvents[0].value;
  // let copy = { ...eventDetail };
  // const copy = allEvents[0];
  // setEventDetail(allEvents[0]);
  // }
  // }, [initialValues.meetup, allEvents, eventDetail, selectedEvent]);
  // }, []);

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column-reverse',
        height: '100%',
        [mediaQueries.phoneOnly]: {
          height: '100%',
        },
        [mediaQueries.desktopUp]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        },
      }}
    >
      {landing && formCompleted ? (
        <FinalBlockLanding selectedEvent={selectedEvent} />
      ) : (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          initialErrors={initialValues}
          validateOnChange={true}
          validationSchema={FormBlockSchema}
          // validate={async (values) => {
          //   // manager.set(FORM_NAME, values);
          // }}
          onSubmit={async (values, actions) => {
            setIsLoading(true);

            let {
              meetup,
              firstName,
              lastName,
              phoneNumber,
              email,
              utmSource,
              gclid,
              fbclid,
              referrer,
              zipCode,
            } = values;

            try {
              const dataUser = {
                meetup,
                firstName,
                lastName,
                phoneNumber,
                email,
                utmSource,
                gclid,
                fbclid,
                zipCode,
                referrer,
                source: document.location.href,
              };
              const response = await axios.post(
                `${process.env.GATSBY_SPUTNIK_API}/api/meetups/attendees`,
                {
                  ...dataUser,
                  track: {
                    utmSource:
                      Cookies.get('utm_source') || landing ? 'lp-reunion-information' : ' ',
                    utmMedium: Cookies.get('utm_medium') || '',
                    utmCampaign: Cookies.get('utm_campaign') || '',
                    utmCampaignId: Cookies.get('utm_campaign_id') || '',
                    adGroupName: Cookies.get('adgroup_name') || '',
                    utmAdGroupId: Cookies.get('utm_adgroup_id') || '',
                    utmTerm: Cookies.get('utm_term') || '',
                    matchType: Cookies.get('matchtype') || '',
                    utmContent: Cookies.get('utm_content') || '',
                  },
                }
              );
              if (response.status === 200) {
                setIsLoading(false);
                window.dataLayer.push({
                  event: 'dateSelection',
                  date: meetup,
                });
                window.dataLayer.push({
                  event: 'registerMeetup',
                });

                if (window.lintrk) window.lintrk('track', { conversion_id: 9849684 });

                manager.set(FORM_NAME, true);
                if (pageType === 'landingPage') {
                  if (response.data.calendar_link) {
                    Cookies.set('meeting_calendar_link', response.data.calendar_link, {
                      expires: 1,
                    });
                  }
                  setFormCompleted(true);
                } else {
                  navigate(`/validation/inscription-reunion`, {
                    state: {
                      calendarURL: response.data.calendar_link,
                    },
                  });
                }
              } else {
                setIsLoading(false);
                setFormError(true);
                actions.setSubmitting(false);
              }
            } catch (error) {
              console.error(error.message);
              setFormError(true);
              actions.setSubmitting(false);
            }
          }}
        >
          {({ errors, handleChange, touched, values, isValid, setFieldValue, isSubmitting }) => {
            return (
              <Form>
                <div
                  css={{
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                  }}
                >
                  {landing ? null : (
                    <>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label>Date&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>
                      <Select
                        styles={selectStyleLarge}
                        name="meetup"
                        isSearchable={true}
                        defaultValue={
                          selectedEvent !== undefined
                            ? allEvents.find((option) => option.value === selectedEvent.value)
                            : allEvents[0]
                        }
                        onChange={(value) => {
                          setFieldValue('meetup', value.value);
                          let copy = { ...eventDetail };
                          copy = value;
                          setEventDetail(copy);
                        }}
                        options={allEvents}
                        errorStyle={errors.event && touched.event ? true : false}
                      />
                      <ErrorMessage
                        isVisible={errors.subject && touched.subject}
                        message={errors.subject}
                      />
                    </>
                  )}

                  <TwoInputWrapper landing={landing} padding>
                    <div>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label css={{ paddingBottom: landing ? 3 : null }}>Prénom&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>
                      <InputForm
                        name="firstName"
                        onChange={handleChange}
                        value={values.firstName}
                        errorStyle={errors.firstName && touched.firstName ? true : false}
                        css={{
                          [mediaQueries.desktopUp]: {
                            minWidth: 250,
                          },
                        }}
                      />
                      <ErrorMessage
                        isVisible={errors.firstName && touched.firstName}
                        message={errors.firstName}
                      />
                    </div>
                    <RightInputWrapper>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label css={{ paddingBottom: landing ? 3 : null }}>Nom&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>

                      <InputForm
                        name="lastName"
                        errorStyle={errors.lastName && touched.lastName ? true : false}
                        onChange={handleChange}
                        value={values.lastName}
                        css={{
                          [mediaQueries.desktopUp]: {
                            minWidth: 250,
                          },
                        }}
                      />
                      <ErrorMessage
                        isVisible={errors.lastName && touched.lastName}
                        message={errors.lastName}
                      />
                    </RightInputWrapper>
                  </TwoInputWrapper>

                  <TwoInputWrapper landing={landing} padding>
                    <div>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label css={{ paddingBottom: landing ? 3 : null }}>Code postal&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>
                      <InputForm
                        name="zipCode"
                        type="text"
                        onChange={(e) => {
                          const newValue = e.target.value.replace(/[^0-9]/g, '');
                          setFieldValue('zipCode', newValue);
                        }}
                        errorStyle={errors.zipCode && touched.zipCode ? true : false}
                        value={values.zipCode}
                        css={{
                          [mediaQueries.desktopUp]: {
                            minWidth: 250,
                          },
                        }}
                      />
                      <ErrorMessage
                        isVisible={errors.zipCode && touched.zipCode}
                        message={errors.zipCode}
                      />
                    </div>
                    <RightInputWrapper>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label css={{ paddingBottom: landing ? 3 : null }}>Téléphone&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>

                      <InputPhone
                        errors={errors}
                        touched={touched}
                        placeholder="Entrez votre numéro"
                        autoComplete="tel"
                        country="FR"
                        defaultCountry="FR"
                        flags={flags}
                        displayInitialValueAsLocalNumber={true}
                        value={values.phoneNumber}
                        onChange={(number) => {
                          setFieldValue('phoneNumber', number);
                        }}
                        css={{
                          [mediaQueries.desktopUp]: {
                            minWidth: 250,
                          },
                        }}
                      />
                      <ErrorMessage
                        isVisible={errors.phoneNumber && touched.phoneNumber}
                        message={errors.phoneNumber}
                      />
                    </RightInputWrapper>
                  </TwoInputWrapper>

                  <TwoInputWrapper landing={landing} padding>
                    <div css={{ width: '100%' }}>
                      <div
                        css={{
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <Label css={{ paddingBottom: landing ? 3 : null }}>Email&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>
                      <InputFormLarge
                        name="email"
                        type="text"
                        onChange={handleChange}
                        errorStyle={errors.email && touched.email ? true : false}
                        value={values.email}
                      />
                      <ErrorMessage
                        isVisible={errors.email && touched.email}
                        message={errors.email}
                      />
                    </div>
                  </TwoInputWrapper>

                  <div
                    css={{
                      paddingTop: 5,
                      paddingBottom: 10,
                    }}
                  >
                    <NextBtn
                      secondary={landing ? true : false}
                      type="submit"
                      disabledStyle={!isValid}
                      disabled={isSubmitting}
                      isFullWidth
                      // theme="primary"
                      css={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 20,
                        border: 'none',
                        [mediaQueries.desktopUp]: {
                          width: landing ? '100%' : null,
                        },
                        [mediaQueries.phoneOnly]: {
                          width: landing ? '100%' : null,
                        },
                        '&:hover': {
                          color: colors.white,
                        },
                      }}
                    >
                      {isLoading ? (
                        <MoonLoader color={'#fff'} size={20} />
                      ) : landing ? (
                        `Je participe la réunion d'information !`
                      ) : (
                        "S'inscrire"
                      )}
                    </NextBtn>
                  </div>
                  <div css={{ paddingBottom: 10 }}>
                    {formError === true && (
                      <ErrorMessage
                        isVisible={true}
                        message={'Une erreur est survenue, veuillez réessayer'}
                      />
                    )}
                  </div>

                  <SentenceSmall>* Champ obligatoire</SentenceSmall>
                </div>
              </Form>
            );
          }}
        </Formik>
      )}

      {landing ? null : (
        <div
          css={{
            display: 'flex',
            borderRadius: 10,
            flexDirection: 'column',
            marginBottom: 30,
            [mediaQueries.desktopUp]: {
              marginLeft: 90,
              marginBottom: 0,
              padding: 45,
              marginTop: 0,
              backgroundColor: colors.lightGrey,
            },
          }}
        >
          <div
            css={{
              [mediaQueries.desktopUp]: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              },
            }}
          >
            <StyledDate>{eventDetail && eventDetail.date}</StyledDate>
          </div>
          <SubtitleDescription css={{ marginBottom: 14 }}>
            {eventDetail && eventDetail.type}
          </SubtitleDescription>
          <StyledSentence>
            Assistez à la réunion d’information concernant le Coding Bootcamp Full-Stack JavaScript
            (
            <StyledLinkMedium to="/bootcamp-javascript/formation-developpeur-web-mobile/">
              à temps plein
            </StyledLinkMedium>
            ,{' '}
            <StyledLinkMedium to="/bootcamp-javascript/formation-developpeur-web-mobile-temps-partiel/">
              à temps partiel
            </StyledLinkMedium>{' '}
            ou{' '}
            <StyledLinkMedium to="/formation-alternance/concepteur-developpeur-applications/">
              en alternance
            </StyledLinkMedium>
            ) et notre formation en{' '}
            <StyledLinkMedium to="/cours-informatique/formation-developpeur-web/">
              e-learning + mentoring
            </StyledLinkMedium>
            .
          </StyledSentence>
          <StyledSentence css={{ marginTop: 10, marginBottom: 25 }}>
            La réunion sera animée par Xavier Colombel (CEO), toutes les 2 semaines, les mercredis.
          </StyledSentence>

          <div
            css={{
              flex: 1,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              // alignItems: 'flex-start',
              justifyContent: 'space-between',
              [mediaQueries.phoneOnly]: {
                paddingTop: 16,
              },
              [mediaQueries.tabletPortraitUp]: {
                flexDirection: 'row',
                paddingTop: 10,
              },
              [mediaQueries.desktopUp]: {
                flexDirection: 'column',
              },
            }}
          >
            {eventDetail && eventDetail.isOnline !== true ? (
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'left',
                  flex: 1,
                  marginBottom: 14,
                  [mediaQueries.tabletPortraitUp]: {
                    flex: 2,
                    marginRight: 16,
                  },
                }}
              >
                <IconWrapper
                  css={{
                    [mediaQueries.tabletLandscapeUp]: {
                      paddingLeft: 5,
                    },
                  }}
                >
                  <Location
                    css={{
                      marginTop: 2,
                      [mediaQueries.phoneOnly]: {
                        marginTop: 0,
                      },
                    }}
                  />
                </IconWrapper>
                <div>
                  <StyledSentence css={{ fontWeight: 'bold' }}>Le Reacteur</StyledSentence>
                  <StyledSentence>
                    55, Rue Etienne Marey
                    <br />
                    75020 - Paris
                  </StyledSentence>
                </div>
              </div>
            ) : (
              <ContactInfoItem
                css={{
                  marginBottom: 14,
                  alignItems: 'center',
                  [mediaQueries.tabletLandscapeUp]: {
                    paddingTop: 0,
                  },
                }}
              >
                <IconWrapper>
                  <CameraBlack />
                </IconWrapper>
                <StyledSentence>
                  Visio-conférence <br /> (via Zoom)
                </StyledSentence>
              </ContactInfoItem>
            )}

            <ContactInfoItem
              css={{
                marginBottom: 14,
                alignItems: 'center',
                [mediaQueries.tabletLandscapeUp]: {
                  paddingTop: 0,
                },
              }}
            >
              <IconWrapper>
                <Clock />
              </IconWrapper>
              <StyledSentence>{eventDetail && eventDetail.time}</StyledSentence>
            </ContactInfoItem>
            <ContactInfoItem
              css={{
                marginBottom: 14,
                alignItems: 'center',
                [mediaQueries.tabletLandscapeUp]: {
                  paddingTop: 0,
                },
              }}
            >
              <IconWrapper>
                <Price />
              </IconWrapper>
              <StyledSentence>Gratuit</StyledSentence>
            </ContactInfoItem>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormBlock;
